export enum ReactQueryKeys {
  SENDERS = "senders",
  TEMPLATES = "templates",
  TEMPLATE = "template",
  MAILS = "mails"
}
